import * as types from "../types/stores.types";

const initialState = {
    list_stores: [],
    banners: [],
};
const stores = (state = initialState, action) => {
    switch (action.type) {
        case types.STORES_AND_BRAND_RESULT:
            const {stores, banners} = action.payload;
            return {...state, list_stores:stores, banners};
        default:
            return state;
    }
};

export default stores;
